<header class="header" [class.scrolled]="isScrolled()">
  <div class="container-wide nav-wrapper">
    
    <!-- Brand Logo -->
    <a href="#home" class="logo-brand-link" (click)="setActive('home')">
      <img src="/Ambition_built_logo.png" alt="Ambition Built Luxury Architectural Homes" class="site-brand-logo">
    </a>

    <!-- Desktop Navigation -->
    <nav class="nav-links">
      <a href="#home" class="nav-link" [class.active]="activeSection() === 'home'" (click)="setActive('home')">HOME</a>
      <a href="#about" class="nav-link" [class.active]="activeSection() === 'about'" (click)="setActive('about')">ABOUT</a>
      <a href="#services" class="nav-link" [class.active]="activeSection() === 'services'" (click)="setActive('services')">SERVICES</a>
      <a href="#projects" class="nav-link" [class.active]="activeSection() === 'projects'" (click)="setActive('projects')">PROJECTS</a>
      <a href="#process" class="nav-link" [class.active]="activeSection() === 'process'" (click)="setActive('process')">OUR PROCESS</a>
      <a href="#contact" class="nav-link" [class.active]="activeSection() === 'contact'" (click)="setActive('contact')">CONTACT</a>
    </nav>

    <!-- Header Action Buttons -->
    <div class="nav-actions">
      @if (isAdminLoggedIn()) {
        <a routerLink="/admin/dashboard" class="btn-gold-sm">
          ADMIN DASHBOARD
        </a>
      }

      <button (click)="openConsultationModal()" class="btn-outline-gold">
        BOOK A CONSULTATION
      </button>

      <!-- Mobile Hamburger Toggle -->
      <button class="mobile-toggle" (click)="toggleMobileMenu()" [class.active]="mobileMenuOpen()" aria-label="Toggle Navigation">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

  </div>

  <!-- Mobile Navigation Drawer -->
  <div class="mobile-drawer" [class.open]="mobileMenuOpen()">
    <div class="mobile-drawer-inner">
      @if (isAdminLoggedIn()) {
        <a routerLink="/admin/dashboard" class="admin-drawer-link" (click)="closeMobileMenu()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          ADMIN DASHBOARD
        </a>
      }
      <a href="#home" [class.active]="activeSection() === 'home'" (click)="setActive('home')">HOME</a>
      <a href="#about" [class.active]="activeSection() === 'about'" (click)="setActive('about')">ABOUT</a>
      <a href="#services" [class.active]="activeSection() === 'services'" (click)="setActive('services')">SERVICES</a>
      <a href="#projects" [class.active]="activeSection() === 'projects'" (click)="setActive('projects')">PROJECTS</a>
      <a href="#process" [class.active]="activeSection() === 'process'" (click)="setActive('process')">OUR PROCESS</a>
      <a href="#contact" [class.active]="activeSection() === 'contact'" (click)="setActive('contact')">CONTACT</a>

      <button (click)="openConsultationModal()" class="btn-gold mobile-cta">
        BOOK A CONSULTATION
      </button>
    </div>
  </div>
</header>
